import { render, staticRenderFns } from "./Discrepancy.vue?vue&type=template&id=20d9cb2a"
import script from "./Discrepancy.vue?vue&type=script&lang=js"
export * from "./Discrepancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports